// Clients and per-client setup snippets for Connect to Claude (D32).

export type ClaudeClient = 'claude-code' | 'claude-desktop' | 'cursor' | 'other'

export const CLIENTS: { id: ClaudeClient; label: string; hint: string }[] = [
  { id: 'claude-code', label: 'Claude Code', hint: 'Run one command in your terminal.' },
  { id: 'claude-desktop', label: 'Claude Desktop', hint: 'Add a block to claude_desktop_config.json (needs Node.js).' },
  { id: 'cursor', label: 'Cursor', hint: 'Add a block to ~/.cursor/mcp.json.' },
  { id: 'other', label: 'Other MCP client', hint: 'Any client that accepts a server URL and a header.' },
]

export function clientSnippet(client: ClaudeClient, url: string, secret: string): { label: string; code: string } {
  const header = `Authorization: Bearer ${secret}`
  switch (client) {
    case 'claude-code':
      return {
        label: 'Terminal',
        code: `claude mcp add --transport http symone "${url}" \\\n  --header "${header}"`,
      }
    case 'claude-desktop':
      // Claude Desktop's config file starts local (stdio) servers only; mcp-remote bridges
      // to a remote HTTP server and forwards the header (AUTH_HEADER avoids the space-in-
      // args problem on Windows).
      return {
        label: 'claude_desktop_config.json',
        code: JSON.stringify(
          {
            mcpServers: {
              symone: {
                command: 'npx',
                args: ['-y', 'mcp-remote', url, '--header', 'Authorization:${AUTH_HEADER}'],
                env: { AUTH_HEADER: `Bearer ${secret}` },
              },
            },
          },
          null,
          2,
        ),
      }
    case 'cursor':
      return {
        label: '~/.cursor/mcp.json',
        code: JSON.stringify({ mcpServers: { symone: { url, headers: { Authorization: `Bearer ${secret}` } } } }, null, 2),
      }
    case 'other':
      return { label: 'Server settings', code: `URL:     ${url}\nHeader:  ${header}` }
  }
}
